/** @flow */
import { formValueSelector } from 'redux-form/immutable';


export default function createFormValueSelector(formName, ...rest) {
  return formValueSelector(formName, ...rest);
}

